// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XlzFs","input":"styles_input__1PtZE"};